module.exports = __webpack_public_path__ + "img/veil_nebula_6-26-21_rev2.1adeeea9.jpg";